export enum ImportTypeConstant {
  SALES_ORDERS = 'sales_orders',
  INVENTORY_QUANTITIES = 'inventory_quantities',
  MASTER_SKUS = 'master_skus',
  SKU_UNIT_COSTS = 'sku_unit_costs',
  LOT_LANDED_COSTS = 'lot_landed_costs',
  SUPPLIER_PRODUCT_SKUS = 'supplier_product_skus',
  HISTORICAL_PURCHASE_ORDERS = 'historical_purchase_orders',
  CLIENT_SHIPPING_ADDRESSES = 'client_shipping_addresses',
  APP_INTEGRATION_ACCOUNT_PRODUCTS = 'app_integration_account_products',
  SHOPIFY_PRODUCTS = 'shopify_products',
  PRODUCT_PREFERRED_VENDOR = 'product_preferred_vendor',
  CHANNEL_PRODUCTS = 'channel_products',
  SUPPLIERS = 'suppliers',
  BOMS = 'boms',
  SALES_ORDER_ITEM_QUANTITY_UPDATE = 'sales_order_item_quantity_update',
  SKU_COST_LAYER_UNIT_COST_OVERRIDE = 'sku_cost_layer_unit_cost_override',
  KITS = 'kits',
  FULFILLMENT_ORDERS = 'fulfillment_orders',
}

export enum EImportColumnField {
  PRODUCT_SUB_CATEGORY = 'PRODUCT_SUB_CATEGORY',
  PRODUCT_CATEGORY = 'PRODUCT_CATEGORY',
  MASTER_SKU = 'MASTER_SKU',
  SALES_REP_EMAIL = 'Sales_Rep_Email',
  SALES_REP_NAME = 'Sales_Rep_Name',
}
